import React from 'react';
import logo from '../assets/logo/logo.png';

const Preloader = () => {
    return (
        <div style={{
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#ffffff'
        }}>
            <img 
                src={logo} 
                alt="Logo PaxDriver" 
                style={{ 
                    maxWidth: '200px', 
                    height: 'auto' 
                }} 
            />
        </div>
    );
};

export default Preloader;
